<template>
  <div v-if="show">
    <div class="logout-dialog-background" @click="emitClose"></div>
    <div class="logout-dialog">
      <div
        class="logout-dialog-button"
        @click="performLogout"
        v-html="$ml.get('option1')"
      >
        <div class="dialog-button-text"></div>
      </div>
      <div class="logout-dialog-button-divider"></div>
      <div class="logout-dialog-button" @click="goBack($ml.get('link'))">
        <div class="dialog-button-text" v-html="$ml.get('option2')"></div>
      </div>
      <button
        class="btn abort-btn"
        style="margin-top: 20px"
        @click="emitClose"
        v-text="$ml.get('btnCancel')"
      ></button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { MLBuilder } from "vue-multilanguage";
export default {
  name: "LogoutDialog",
  props: {
    show: { type: Boolean, default: false },
  },
  computed: {
    mlLink() {
      return this.$ml.with("VueJS").get("logo");
    },
  },
  methods: {
    ...mapActions("authentication", ["logout"]),
    async performLogout() {
      try {
        await this.logout();
        this.goBack(this.$ml.get("link"));
      } catch (e) {
        this.goBack(this.$ml.get("link"));
      }
    },
    emitClose() {
      this.$emit("close");
    },
    goBack(url) {
      window.location = url;
    },
  },
};
</script>

<style scoped>
.logout-dialog-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9997;
  background-color: rgba(0, 0, 0, 0.6);
}

.logout-dialog {
  position: fixed;
  background: linear-gradient(to right, #0a345f, #0178b7);
  padding: 20px;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  z-index: 9998;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logout-dialog-button {
  height: 100px;
  background-color: #00a7ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.logout-dialog-button:hover {
  background-color: #0178b7;
}

.logout-dialog-button-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}

.dialog-button-text {
  user-select: none;
  font-size: 1.1rem;
}

@media (max-width: 576px) {
  .logout-dialog {
    width: 100%;
  }
}
</style>
